<template>
    <div class="container">
        <div class="row">
            <div class="col-sm-2">
                LeftMenu
            </div>
            <div class="col-sm-10">
                <div class="row">
                    <div class="col-sm-12">
                        Top
                        <ul>
                            <li>
<!--                                <v-link href="/">Home</v-link>-->
                                <router-link to="/">Home</router-link>
                            </li>
                            <li>
                                <router-link to="/about">About</router-link>
                            </li>
                            <li>
                                <router-link to="/test">Test</router-link>
                            </li>
                            <li>
                                <router-link to="/xxx">Test</router-link>
                            </li>
                            <li>
                                <router-link to="/yyy">Test</router-link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        right
                        <slot></slot>
                    </div>
                </div>
            </div>
        </div>



    </div>
</template>

<script>
    // import VLink from './../components/VLink.vue'

    export default {
        components: {
            // VLink
        }
    }
</script>

<style scoped>
    /*.container {*/
    /*    max-width: 600px;*/
    /*    margin: 0 auto;*/
    /*    padding: 15px 30px;*/
    /*    background: #f9f7f5;*/
    /*}*/
</style>